module.exports = __webpack_public_path__ + "fonts/Ogg-Regular.c413c77.otf";